/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines possible sources of information.
 */
export var ReadingSource;
(function (ReadingSource) {
    ReadingSource["CAT"] = "CAT";
    ReadingSource["THIRD_PARTY"] = "ThirdParty";
    ReadingSource["USER"] = "User";
})(ReadingSource || (ReadingSource = {}));
